import HttpService from "../baseHttp";

export const HttpGetLineList = (data = {}, config) => HttpService.get('/api/v1/ProductLine/findByPage', { params: data })

export const HttpGetProductsLine = (data = {}, config) => HttpService.get('/api/v1/ProductLine/getById', { params: data })

export const HttpEditLine = (data = {}, config) => HttpService.post('/api/v1/ProductLine/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

export const HttpDeletedLine = (data = {}, config) => HttpService.get('/api/v1/ProductLine/cancel', { params: data })




